import { Record } from 'immutable';

const CategoryRecord = Record({
  cicCategoryId: undefined,
  cicCategoryName: undefined,
});

class Category extends CategoryRecord { }

export default Category;




// WEBPACK FOOTER //
// ./data/CoveredInClass/CategoryTemplate/model.js